<template>
  <div class="app">
    <h1>新闻资讯</h1>
    <Header :activeIndex="'9'" />

    <div class="tiaozhuan"><span style="cursor: pointer;" @click="pathIndex">首页</span><span>&nbsp;&gt;&gt;&nbsp;</span><span>老板学院</span></div>
    <div class="margintop">
      <table class="tableCSS">
        <tbody>
          <tr v-for="(news, index) in newsList" :key="news.id">
            <td class="tdCSS1">{{ news.createTime }}</td>
            <td class="tdCSS">
              <a style="cursor: pointer;" @click="handleClick(news.id, getPreviousId(index), getNextId(index))">{{ news.title }}</a>
            </td>
            <td class="tdCSS">
              <a class="look" style="cursor: pointer;" @click="handleClick(news.id, getPreviousId(index), getNextId(index))" title="查 看">查 看</a>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="showContent" v-html="formattedContent"></div>
      <div class="yema">
        <el-pagination layout="prev, pager, next, total" :total="total" :page-size="15" ref="pagination"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'xueyuan',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      newsList: [],
      currentPage: 1,
      total: 0,
      showContent: '',
      pppclose: true,
      beforefont: '',
    }
  },
  mounted() {
    this.fetchNews();
    window.scrollTo(0, 0);
    this.$root.showData.showData = false;
  },
  methods: {
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    getPreviousId(index) {
      if (index > 0) {
        return this.newsList[index - 1].id;
      }
      return null; // 如果没有上一行，返回 null
    },
    // 获取下一行的 ID
    getNextId(index) {
      if (index < this.newsList.length - 1) {
        return this.newsList[index + 1].id;
      }
      return null; // 如果没有下一行，返回 null
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
      const urlWithId = `${contentPageUrl}?id=${id}`;

      // 在新标签页打开带 id 的 URL
      window.open(urlWithId, '_blank');
    },
    // handleClick(id,previousId, nextId) {
    //   const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
    //   const urlWithId = `${contentPageUrl}?id=${id}&previousId=${nextId}&nextId=${previousId}`;

    //   // 在新标签页打开带 id 的 URL
    //   window.open(urlWithId, '_blank');
    // },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchNews()
    },
    fetchNews() {
      // 假设这里是你的后端接口
      fetch(`https://mingqicaiwu.com:8201/admin/news/getTitle/${this.currentPage}/10`)
        .then(response => response.json())
        .then(data => {
          this.total = data.data.total
          this.newsList = data.data.listPage.records
        })
        .catch(error => {
          alert("查询失败，请重新刷新")
          console.error("分页查询出错，原因是", error);
        })
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    }
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-pagination {
    white-space: nowrap;
    padding: 0px 5px;
    color: #303133;
    font-weight: 700;
}
}
</style>

<style scoped>
/* 表格 */
.look {
  display: block;
  width: 57px;
  height: 24px;
  line-height: 26px;
  text-align: center;
  background-color: #d42828;
  color: #fff;
  font-size: 14px;
  border-radius: 12px;
}

.yema {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.tableCSS {
  width: 720px;
  overflow: hidden;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.tdCSS1 {
  width: 84px;
  padding: 8px;
  text-align: center;
  border: none;
  font-size: 18px;
  color: #d22525;
  font-weight: 700;
}

.tdCSS {
  padding: 8px;
  text-align: left;
  border: none;
  font-size: 16px;
}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 118px; */
  flex-direction: column;
}

.tiaozhuan {
  margin-top: 118px;
  text-align: left;
  margin-bottom: 0.83em;
  font-size:18px;
  margin-left: 19.5%;
  font-weight: 500;
}


@media (max-width: 768px) {

  /* 表格 */
  .look {
    display: block;
    width: 40px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #d42828;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
  }

  .yema {
    margin-top: 1vh;
    margin-left: auto;
    margin-right: auto;
  }

  .tableCSS {
    width: 90%;
    overflow: hidden;
    margin-top: 3px;
    border: 1px solid #ddd;
    border-collapse: collapse;
    font-size: 13px;
  }

  .tdCSS1 {
    width: 40px;
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 13px;
  }

  .tdCSS {
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 13px;
  }


  /* 其他 */
  .margintop {
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 95px; */
  }

  .tiaozhuan {
    margin-top: 100px;
    text-align: left;
    margin-bottom: 0.83em;
    margin-left: 2%;
    font-size:11px;
  }
}</style>


// WEBPACK FOOTER //
// src/components/xueyuan.vue